<template>
  <div>
    <!-- {{ $store.getters.isAgent }} -->
    <h3 style="margin-bottom: 0;">References
      <span v-if="editAccess" style="float: right; cursor: pointer;" @click="showReferenceModal()">+</span>
    </h3>
    <small v-if="references.length < 3 && editAccess">Please list at least 3 previous placement references; Babysitting, Nannying, Daycare, Church Nursery or Summer Camps</small>
    <hr>
    <div v-for="reference in references" :key="reference.id" class="px-2">
      <h5 style="font-weight: 600; margin-bottom: 0;">{{ reference.first_name }} <span v-if="editAccess">{{ reference.last_name }}</span>
        <img v-if="editAccess" src="../../../assets/img/icons/edit_icon_simple.svg" alt="" width="16px" style="float: right; cursor: pointer;" @click="showReferenceModal(reference)">
      </h5>
      <div class="row">
        <div class="col-lg-3">
          <label v-if="reference.relationship">Relationship</label>
          <p>{{ reference.relationship }}</p>
        </div>
        <div class="col-lg-3" v-if="editAccess">
          <label v-if="reference.phone">Phone</label>
          <p>{{ reference.phone }}</p>
        </div>
        <!-- <div class="col-lg-3" v-if="editAccess">
          <label v-if="reference.phone2">Other Phone</label>
          <p>{{ reference.phone2 }}</p>
        </div> -->
        <div class="col-lg-3" v-if="editAccess">
          <label v-if="reference.email">Email</label>
          <p>{{ reference.email }}</p>
        </div>
      </div>
      <!-- <hr style="margin-bottom: 0;"> -->
      <div class="row">
        <div class="col-lg-12">
          <label v-if="reference.text1">Description</label>
          <pre>{{ reference.text1 }}</pre>
          <!-- <label v-if="reference.text2">Ages of Children</label>
          <p>{{ reference.text2 }}</p>
          <label v-if="reference.text3">Years Worked With Them</label>
          <p>{{ reference.text3 }}</p>
          <label v-if="reference.text4">How Frequently I Worked For Them</label>
          <p>{{ reference.text4 }}</p> -->
        </div>
        <!-- <div class="col-lg-6">
          <label v-if="reference.text5">Job Expectations With This Family/Organization</label>
          <p>{{ reference.text5 }}</p>
        </div> -->
      </div>
      <div v-if="adminOrEmployer && reference.reference_note">
        <hr>
        <label style="margin-top: 0;">Reference Check Notes</label>
        <pre>{{ reference.reference_note }}</pre>
      </div>
      <button v-if="$store.getters.isAgent === true" class="mylisting-button dark-button mt-4" @click="showReferenceInterviewNotesModal(reference)" style="">Log Reference Check Notes</button>
      <hr>
    </div>

    <modal name="reference-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h3 v-if="!reference.id">Add Reference</h3>
        <h3 v-if="reference.id">Edit Reference - {{ reference.first_name }} {{ reference.last_name }}</h3>
        <hr style="margin-bottom: 0;">
        <div class="row">
          <div class="col-lg-6 px-4 mb-4">
            <label>First Name*</label>
            <input type="text" class="form-control" v-model="firstName">
            <label>Last Name*</label>
            <input type="text" class="form-control" v-model="lastName">
            <label>Relation</label>
            <small style="display: block;" class="mb-1">Ex. Babysitting Family, Nanny Family, Summer Camp Director</small>
            <input type="text" class="form-control" v-model="relationship">
            <label>Mobile Phone*</label>
            <input type="text" class="form-control" v-model="phone">
            <!-- <label>Other Phone</label>
            <input type="text" class="form-control" v-model="phone2"> -->
            <label>Email*</label>
            <input type="text" class="form-control" v-model="email">
          </div>
          <div class="col-lg-6 px-4">
            <!-- <label>Number of Children Cared for*</label>
            <input type="text" class="form-control" v-model="numChildren">
            <label>Ages of Children When Hired*</label>
            <input type="text" class="form-control" v-model="ageChildren">
            <label>Specific Number of Years Worked With Them*</label>
            <small style="display: block;" class="mb-1">Ex. 3 years, 2012-2015</small>
            <input type="text" class="form-control" v-model="years">
            <label>How Frequently Did You Work For Them?*</label>
            <small style="display: block;" class="mb-1">Ex. Casual Babysitting 1-2x/month, Part-time Nanny 3 days/week</small>
            <input type="text" class="form-control" v-model="frequency"> -->
            <label>Description*</label>
            <textarea rows="5" class="form-control" v-model="description"></textarea>
          </div>
        </div>
        <hr>
        <div>
          <button class="mylisting-button secondary-button" @click="hideReferenceModal()">Cancel</button>
          <button v-if="reference.id" class="mylisting-button danger-button" @click="showDeleteReferenceModal()" style="">Delete</button>
          <button v-if="!reference.id" class="mylisting-button dark-button" @click="postReference()" style="float: right;">Save</button>
          <button v-if="reference.id" class="mylisting-button dark-button" @click="updateReference(reference)" style="float: right;">Save</button>
        </div>
      </div>
    </modal>

    <modal name="reference-interview-notes-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Add Reference Interview Notes</h2>
        <hr>
        <!-- <label></label> -->
        <textarea rows="10" class="form-control" v-model="referenceInterviewNotes"></textarea>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('reference-interview-notes-modal')">Cancel</button>
        <button v-if="reference.id" class="mylisting-button dark-button" @click="saveReferenceInterviewNotes(reference)" style="float: right;">Save</button>
      </div>
    </modal>

    <modal name="reference-interview-notes-updated-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Reference notes updated.</h2>
        <hr>
        <button class="mylisting-button dark-button" @click="$modal.hide('reference-interview-notes-updated-modal')">Done</button>
      </div>
    </modal>

    <modal name="delete-reference-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Are you sure you want to delete this reference?</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('delete-reference-modal')">Cancel</button>
        <button v-if="reference.id" class="mylisting-button danger-button" @click="deleteReference(reference)" style="float: right;">Delete</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['user'],
  data() {
    return {
      references: [],
      reference: {},
      firstName: '',
      lastName: '',
      relationship: '',
      phone: '',
      phone2: '',
      email: '',

      // numChildren: '',
      // ageChildren: '',
      // years: '',
      // frequency: '',
      // jobDescription: '',
      description: '',

      referenceInterviewNotes: '',
    }
  },
  computed: {
    editAccess() {
      if (this.user.id == this.$store.getters.userID || this.$store.getters.isAgent === true) {
        return true
      } else {
        return false
      }
    },
    viewOnlyAccess() {
      if (this.$store.getters.isEmployer === true) {
        return true
      } else {
        return false
      }
    },
    adminOrEmployer() {
      if (this.$store.getters.isAgent === true || this.$store.getters.isEmployer === true) {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    this.getReferences()
  },
  methods: {
    getReferences() {
      axios.get(`/api/references/?user=${this.user.id}`)
        .then(res => {
          this.references = res.data
          this.references = this.references.sort((a, b) => (a.id > b.id) ? 1 : -1)
        })
        .catch(error => {
          console.log(error)
        })
    },
    showReferenceModal(reference) {
      if (reference) {
        this.reference = reference
        this.firstName = reference.first_name
        this.lastName = reference.last_name
        this.relationship = reference.relationship
        this.phone = reference.phone
        this.phone2 = reference.phone2
        this.email = reference.email
        // this.numChildren = reference.text1
        // this.ageChildren = reference.text2
        // this.years = reference.text3
        // this.frequency = reference.text4
        // this.jobDescription = reference.text5
        this.description = reference.text1
      }
      else {
        this.reference = {}
        this.firstName = ''
        this.lastName = ''
        this.relationship = ''
        this.phone = ''
        this.phone2 = ''
        this.email = ''
        this.numChildren = ''
        this.ageChildren = ''
        this.years = ''
        this.frequency = ''
        this.jobDescription = ''
      }
      this.$modal.show('reference-modal')
    },
    hideReferenceModal() {
      this.$modal.hide('reference-modal')
    },
    postReference() {
      axios.post('/api/references/', {
        user: this.user.id,
        first_name: this.firstName,
        last_name: this.lastName,
        relationship: this.relationship,
        phone: this.phone,
        phone2: this.phone2,
        email: this.email,
        text1: this.description,
        // text1: this.numChildren,
        // text2: this.ageChildren,
        // text3: this.years,
        // text4: this.frequency,
        // text5: this.jobDescription
      })
        .then(res => {
          console.log(res)
          this.hideReferenceModal()
          this.getReferences()
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateReference() {
      axios.patch(`/api/references/${this.reference.id}/`, {
        user: this.user.id,
        first_name: this.firstName,
        last_name: this.lastName,
        relationship: this.relationship,
        phone: this.phone,
        phone2: this.phone2,
        email: this.email,
        // text1: this.numChildren,
        // text2: this.ageChildren,
        // text3: this.years,
        // text4: this.frequency,
        // text5: this.jobDescription
        text1: this.description
      })
        .then(res => {
          console.log(res)
          this.hideReferenceModal()
          this.getReferences()
        })
        .catch(error => {
          console.log(error)
        })
    },
    showDeleteReferenceModal() {
      this.$modal.show('delete-reference-modal')
    },
    deleteReference(reference) {
      axios.delete(`/api/references/${this.reference.id}/`)
        .then(res => {
          console.log(res)
          this.getReferences()
          this.hideReferenceModal()
          this.$modal.hide('delete-reference-modal')
        })
        .catch(error => {
          console.log(error)
        })
    },
    showReferenceInterviewNotesModal(reference) {
      this.reference = reference
      this.referenceInterviewNotes = reference.reference_note
      this.$modal.show('reference-interview-notes-modal')
    },
    saveReferenceInterviewNotes(reference) {
      axios.patch(`/api/references/${this.reference.id}/`, {
        reference_note: this.referenceInterviewNotes
      })
        .then(res => {
          this.getReferences()
          this.$modal.hide('reference-interview-notes-modal')
          this.$modal.show('reference-interview-notes-updated-modal')
        })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/candidates/profile/References.vue